import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  viewBox: "0 0 24 24",
  class: "w-3.5 h-3.5 shrink-0",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = {
  key: 1,
  class: "text-[12px] text-[#7f7f8e]"
}

import { computed } from 'vue'
import { mdiClockAlertOutline, mdiClockOutline } from '@mdi/js'

import { formatWaiting, isWaitingOverdue, waitingHours } from '../model'


export default /*#__PURE__*/_defineComponent({
  __name: 'WaitingSince',
  props: {
    since: {}
  },
  setup(__props: any) {

const props = __props;



const hours = computed(() => waitingHours(props.since))
const overdue = computed(() => isWaitingOverdue(hours.value))

return (_ctx: any,_cache: any) => {
  return (hours.value !== null)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["inline-flex items-center gap-1 text-[12px] leading-4 whitespace-nowrap", overdue.value ? 'text-alert font-bold' : 'text-[#52526f]']),
        title: overdue.value ? 'Aguardando há mais de 72h' : undefined,
        "data-testid": "waiting-since"
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          _createElementVNode("path", {
            d: overdue.value ? _unref(mdiClockAlertOutline) : _unref(mdiClockOutline),
            fill: "currentColor"
          }, null, 8, _hoisted_3)
        ])),
        _createTextVNode(" aguardando " + _toDisplayString(_unref(formatWaiting)(hours.value)), 1)
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("span", _hoisted_4, "—"))
}
}

})